import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import Layout from "../../../components/Layout";
import EmailSignupBanner from "../../../components/EmailSignupBanner";
import { MenuId } from "../../../components/Header";
import {Button, List, Space, Text} from '@mantine/core';
import Head from "next/head";
import Link from "next/link";
import useAuth from "../../../lib/useAuth";
import { useClerk } from "@clerk/nextjs";

export default function Authorize()
{
    const {userInformation, authToken}=useAuth();
    const {isSignedIn} = useClerk();

    function click(e: React.MouseEvent)
    {
       //let url = "https://api.instagram.com/oauth/authorize?client_id=179437998249978&redirect_uri=https://rawumberstudios.com/n/instagram/authenticated&scope=user_profile,user_media,instagram_graph_user_profile&response_type=code";        
///       let url = "https://api.instagram.com/oauth/authorize?client_id=790250149211150&redirect_uri=https://rawumberstudios.com/n/instagram/authenticated&scope=user_profile,user_media,instagram_graph_user_profile&response_type=code";        

       //removed instagram_graph_user_profile
        //let url = "https://api.instagram.com/oauth/authorize?client_id=179437998249978&redirect_uri=https://rawumberstudios.com/n/instagram/authenticated&scope=user_profile,user_media&response_type=code";        

        //moving to new app and api

        let url = "https://www.instagram.com/oauth/authorize?enable_fb_login=0&force_authentication=1&client_id=938108551020916&redirect_uri=https://rawumberstudios.com/n/instagram/v2.0/authenticated&response_type=code&scope=instagram_business_basic";
       if (isSignedIn)
        {
            url = url + "&state=" + authToken;
        } 
        e.preventDefault();
        location.href=url;
    }
    return (
        <Layout menuId={MenuId.home}>
            <Head>
                <title>Raw Umber Studios</title>
                <meta name="robots" content="noindex"></meta>
            </Head>
            <h1>Raw Umber Studios</h1>
            <h2>Instagram authentication</h2>

            <Text>If you&rsquo;d like us to ...</Text>
            <Space h='md'/>

            <List>
                <List.Item>Automatically pull in your #rawumberlive Instagram posts to our <Link href='/user-images/'>gallery</Link></List.Item>
                <List.Item>Mark anonymous work in our <Link href='/user-images/'>gallery</Link> as yours</List.Item>
                <List.Item>Share your Instagram username with other subscribers</List.Item>
            </List>
            <Space h='md'/>

            <Text>... then please authorize access to Instagram. Note that:</Text>
            <Space h='md'/>


            <List>
                <List.Item>
                we&rsquo;ll be able to read your profile information, and your posts, but <b>we can&rsquo;t change anything or post to your account</b>.
                </List.Item>
            </List>
            <Space h='md'/>

            <Button onClick={click}>Authorize Instagram</Button>
            <Space h='md'/>
            <EmailSignupBanner/>
        </Layout>
    )


}
